import apiClient from './axiosClient';

export const claimApi = {
    searchClaims: async (params) => {
      //  alert("PARAMS : " + JSON.stringify(params));
       // return;
        
        let claimNumber = '';
        let memberId = '';
        let checkNumber = '';
        let accNumber = '';
        let firstName = '';
        let lastName = '';
        let dob = '';

        

        if (params.searchByParams.searchBy === 'claimNumber')
        {
            claimNumber = params.searchByParams.searchValue;
            
        }
        else if (params.searchByParams.searchBy === 'memberId')
        {
            
            memberId = params.searchByParams.searchValue;
            
        }
        else if (params.searchByParams.searchBy === 'checkNumber')
        {
            
            checkNumber = params.searchByParams.searchValue;
            
        }
        else if (params.searchByParams.searchBy === 'accountNumber') {

            accNumber = params.searchByParams.searchValue;

        }
        else if (params.searchByParams.searchBy === 'firstLastDob') {

            firstName = params.searchByParams.firstName;
            lastName = params.searchByParams.lastName;
            dob = params.searchByParams.dob;

        }
      const res= await apiClient.post('/api/claims/select2', {
            
          //billingProvider: params.user.taxId?.trim() ? params.user.taxId?.trim() : params.billingProviderId,
            billingProvider:  params.billingProviderId,
            claimId: claimNumber,
            checkNo: checkNumber,
            accNo: accNumber,
            firstName: firstName,
            lastName: lastName,
            dob: dob,
            groupId:params.group,
            memberId: memberId,
          //  pageLimit: params.dataState.take,
            //pageNo: params.dataState.skip,
           // pageNo: 1,
            serviceEnd: params.serviceEnd,
          serviceStart: params.serviceStart,
          searchText: params.searchText,
          sortColumnName: params.sortColumnName,
          sortColumnDirection: params.sortColumnDirection,
          startIndex: params.startIndex,
          pageSize: params.pageSize
            
        });

        const data = res?.data;


        //console.log("CLAIMS DATA : " + JSON.stringify(data));
        
        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    

  // params: { billingProviderId, serviceStart, serviceEnd, searchBy, searchValue }

    getClaimDetail: async (params) => {
       // alert(claimNumber+"|"+JSON.stringify(user)+"|"+user.taxId);
        const res = await apiClient.get(`/api/eopclaims?billingProvider=${params?.billingProvider?.trim()}&claimNo=${params?.claimNo?.trim()}&checkNo=${params?.checkNo?.trim()}`);
        const data = res?.data;

        
        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []   //  all properties preserved
        };
    },
    //apiClient.get(`/claims/${id}`),
      

  getClaimLineItems: (id) =>
    apiClient.get(`/claims/${id}/line-items`),
};
